import { createContext, useContext } from 'react';
import { AppUiStore, UtilityUiStore } from '../store/uiStore';

const uiStoreContextApp = createContext({ uiStore: new AppUiStore() });

export function useAppUiStore() {
  const context = useContext(uiStoreContextApp);
  if (context === undefined) throw new Error("uiStoreContext was used outside of it's Provider");
  return context;
}

const uiStoreContextUtility = createContext({ uiStore: new UtilityUiStore() });

export function useUtilityUiStore() {
  const context = useContext(uiStoreContextUtility);
  if (context === undefined) throw new Error("uiStoreContext was used outside of it's Provider");
  return context;
}

// Create a context instance
// const SingletonContextInstance = createContext();

// // Custom hook to use the context
// export function useUiStore() {
//   const context = useContext(SingletonContextInstance);
//   if (context === undefined) throw new Error("uiStoreContext was used outside of it's Provider");
//   return context;
// }

// // Provider component for the context
// export const SingletonContextProvider = ({ children }) => {
//   // Your shared state or any other logic can go here
//   const sharedState = {
//     uiStoreInstance,
//   };

//   return (
//     <SingletonContextInstance.Provider value={sharedState}>
//       {children}
//     </SingletonContextInstance.Provider>
//   );
// };

// const uiStoreContext = createContext({ uiStore: uiStoreInstance });
// const uiStoreContext = (function () {
//   let instance;

//   function createInstance() {
//     const context = createContext({ uiStore: uiStoreInstance });
//     return context;
//   }

//   return {
//     getInstance: function () {
//       if (!instance) {
//         instance = createInstance();
//       }
//       return instance;
//     },
//   };
// })();

// //= createContext({ uiStore: new UiStore() });

// export function useUiStore() {
//   const context = useContext(uiStoreContext.getInstance());
//   if (context === undefined) throw new Error("uiStoreContext was used outside of it's Provider");
//   return context;
// }

// export function useFinanceStore() {}
